import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import classnames from 'classnames';
import { Checkbox } from 'primereact/checkbox';
import { getJoin } from './../../actions/joinUsAction';
import { editJoin } from './../../actions/joinUsActionUD';
import queryString from 'query-string';
import { Growl } from 'primereact/growl';
import NotFound from './../../pages/NotFound';
class EditJOIN extends Component {
  constructor() {
    super();
    this.state = {
      reference_id: '',
      directory: '',
      requestSuccessMessage: '',
      requestMessage: '',
      requestFailedMessage: {},
      join: {},
      resType: '',
      title: '',
      content: '',
      // sugg_number: '',
      visible: false,
      init2: false,
      error1: false,
      error2: false,
      error3: false,
      pageTitle: 'Ikar.sy |JOIN',
      pageDescription:
        'سوق العقارات الإلكتروني في سورية Ikar.sy مخصص لجمع عروض بيع، شراء و تأجير العقارات من جميع مكاتب العقارات في سورية. الإعلان على Ikar.sy مجاني و متاح فقط للمكاتب العقارية والمتعهدين المسجلين لدى الموقع في جميع المحافظات السورية. | Ikar.sy',
    };
  }
  componentWillReceiveProps = async (nextProps, nextState) => {
    if (
      nextProps.requestSuccessMessage !== this.state.requestSuccessMessage &&
      this.state.requestSuccessMessage === 'ready' &&
      this.state.requestFailedMessage.error === undefined
    ) {
      this.setState({
        // requestSuccessMessage: nextProps.requestSuccessMessage,
        requestSuccessMessage: nextProps.requestFailedMessage,
      });

      switch (nextProps.requestSuccessMessage) {
        case 'تعديل الاقتراح المحدد':
          this.growl.show({
            severity: 'success',
            summary: 'تم تعديل الاقتراح بنجاح',
          });

          const searchUrlParams = await queryString.parse(
            this.props.locationSearch
          );
          if (searchUrlParams.join_id !== undefined) {
            // agency_ref_id = searchUrlParams.agency_id;
            const id = searchUrlParams.join_id;
            if (id !== undefined && id !== null) {
              this.props.getJoin(true, id);
            }
          }
          break;

        case 'error in edit question':
          this.growl.show({
            severity: 'error',
            summary: 'حدثت مشكلة في تعديل السؤال الرجاء المحاولة لاحقا ',
          });
          break;

        default:
          break;
      }
    } else {
      if (
        nextProps.join !== this.state.join
        //  &&
        // nextProps.requestMessage === 'get join ready'
      ) {
        await this.setState({
          join: nextProps.join,
          title: nextProps.join.title,
          content: nextProps.join.content,
          visible: nextProps.join.visible,
          // sugg_number: nextProps.join.sugg_number,
          reference_id: nextProps.join.reference_id,
        });
      }

      if (
        nextProps.join !== undefined &&
        nextProps.join !== this.state.join &&
        nextProps.requestMessage === 'edit is succeeded'
      ) {
        const {
          title,
          content,
          //  sugg_number,
          visible,
        } = nextProps.join;

        await this.setState({
          title,
          content,
          // sugg_number,
          visible,
        });
      }
    }

    if (
      nextProps.resType !== undefined &&
      nextProps.resType !== this.state.resType
    ) {
      const { resType } = nextProps;
      this.setState({ resType });
    }
  };
  async componentDidMount() {
    const searchUrlParams = await queryString.parse(this.props.locationSearch);

    if (searchUrlParams.join_id !== undefined) {
      // agency_ref_id = searchUrlParams.agency_id;
      const id = searchUrlParams.join_id;
      if (id !== undefined && id !== null) {
        this.props.getJoin(true, id);
      }
    }
  }
  onChange = (e) =>
    this.setState({
      [e.target.name]: e.target.value,
      error1: false,
      error2: false,
      error3: false,
    });
  onEditSubmit = async (str, e) => {
    e.preventDefault();
    const { title, content, visible, reference_id } = this.state;

    // const sugg_number = parseInt(this.state.sugg_number);
    // if (sugg_number === -100 || sugg_number === null) {
    //   this.setState({ error3: true });
    // }
    //question_number = parseInt(question_number);

    if (title === '' || title === null) {
      this.setState({ error1: true });
    }

    if (content === '' || content === null) {
      this.setState({ error2: true });
    }
    //const question_number = 1;
    //const visible = true;
    // const title = "what";
    // const details = "yes";

    const joinObject = {
      title,
      content,
      // sugg_number,
      visible,
      reference_id,
    };
    //let token = localStorage.getItem("ikar_token");
    let res = {};
    let errorRes = {
      errorStatus: '',
      errorMessage: '',
    };
    this.setState({ requestSuccessMessage: 'ready' });
    this.props.editJoin(joinObject, 'تعديل الاقتراح المحدد');
  };
  onCheckBoxChange = async (e) => {
    if (this.state.init2) {
      await this.setState({ init2: false, [e.target.name]: true });
    } else {
      await this.setState({ [e.target.name]: e.target.checked });
    }
  };
  render() {
    const {
      visible,
      title,
      content,
      //  sugg_number,
      join,
      resType,
    } = this.state;

    return (
      <div>
        <Helmet>
          <title>{this.state.pageTitle}</title>
          <meta name="description" content={this.state.pageDescription} />
        </Helmet>
        {/* //////////// */}
        {resType === 'complete' ? (
          <div>
            <Growl ref={(el) => (this.growl = el)} />
            <div className="row">
              <div className="col-md-10 mx-auto">
                <div className="text-center pb-4 pt-3 mb-4">
                  <h1 className="main_title">تعديل اقتراح</h1>
                </div>
              </div>
            </div>
            <form className="search_div  round-div p-1 mb-4">
              <div className="row justify-content-around mb-4">
                <div className="form-group text-right  col-md-6 col-lg-6 col-sm-12 col-xs-12 mb-4 ">
                  <label htmlFor="title">
                    <span> الاقتراح: </span>
                  </label>
                  <div>
                    <textarea
                      rows="2"
                      name="title"
                      className={classnames('form-control', {
                        'is-invalid': this.state.error1,
                      })}
                      placeholder=""
                      value={this.state.title}
                      onChange={this.onChange}
                    />
                  </div>
                  {this.state.error1 ? (
                    <div className="invalid-feedback-custom">
                      الرجاء ادخال الاقتراح{' '}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group text-right col-lg-6 col-md-6 col-sm-12 col-xs-12  mb-4">
                  <label htmlFor="content">
                    التفاصيل: <span className="display_mandatory"></span>
                  </label>
                  <div>
                    <textarea
                      rows="4"
                      name="content"
                      className={classnames('form-control', {
                        'is-invalid': this.state.error2,
                      })}
                      placeholder=""
                      value={this.state.content}
                      onChange={this.onChange}
                    />
                  </div>
                  {this.state.error2 ? (
                    <div className="invalid-feedback-custom">
                      الرجاء ادخال التفاصيل{' '}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
              <div className="row justify-content-around mb-4 ">
                {/* <div className="form-group text-right col-lg-6 col-md-6 col-sm-12 col-xs-12  mb-4"> */}
                {/* <label htmlFor="sugg_number"> رقم الاقتراح:</label>
                  <div>
                    <select
                      name="sugg_number"
                      className={classnames('form-control', 'text-right')}
                      onChange={this.onChange}
                      value={this.state.sugg_number}
                      style={{ width: '50%', marginLeft: '50%' }}
                    >
                      <option value="-100">غير محدد</option>
                      <option value="1"> 1</option>
                      <option value="2"> 2</option>
                      <option value="3"> 3</option>
                      <option value="4"> 4</option>
                      <option value="5"> 5</option>
                      <option value="6"> 6</option>
                      <option value="7"> 7</option>
                      <option value="8"> 8</option>
                      <option value="9"> 9</option>
                      <option value="10"> 10</option>
                      <option value="11"> 11</option>
                      <option value="12"> 12</option>
                      <option value="13"> 13</option>
                      <option value="14"> 14</option>
                      <option value="15"> 15</option>
                      <option value="16"> 16</option>
                      <option value="17"> 17</option>
                      <option value="18"> 18</option>
                      <option value="19"> 19</option>
                      <option value="20"> 20</option>
                      <option value="21"> 21</option>
                      <option value="22"> 22</option>
                      <option value="23"> 23</option>
                      <option value="24"> 24</option>
                      <option value="25"> 25</option>
                      <option value="26"> 26</option>
                      <option value="27"> 27</option>
                    </select>
                  </div>
                  {this.state.error3 ? (
                    <div className="invalid-feedback-custom">
                      الرجاء ادخال رقم الاقتراح{' '}
                    </div>
                  ) : (
                    ''
                  )}
                </div> */}

                <div className="form-group text-right col-lg-12 col-md-12 col-sm-12 col-xs-12  mb-4">
                  <label className="form-check-label " htmlFor="visible">
                    مرئي
                  </label>
                  <span className="form-group text-right ">
                    <Checkbox
                      checked={visible}
                      onChange={(e) => this.setState({ visible: e.checked })}
                    />
                  </span>
                </div>
              </div>
            </form>
            <div className="text-right">
              <span>
                لادخال رابط فيسبوك - يوتيوب - انستغرام - تويتر أو رقم هاتف ضمن
                الجواب يجب اتباع المثال التالي{' '}
              </span>
              <div className="form-group text-right col-12  mb-4">
                <div>
                  <textarea
                    readOnly="true"
                    rows="6"
                    //   className={classnames('form-control', {
                    //     'is-invalid': errors.description,
                    //   })}
                    className={classnames('form-control', 'text-right', {
                      'is-invalid': this.state.error2,
                    })}
                    placeholder=""
                  >{`فيديو يوتيوب
              <<=https://www.youtube.com/channel/UCHc5tI-ELOt7q6ryCoDB_yw/videos;موقع عقار على اليوتيوب;youtube=>>
               صفحة فيسبوك 
              <<=https://www.facebook.com/Ikarsy-109054930712834;افضل موقع عربي للعقارات;facebook=>>
              رقم اتصال 
              <<=00963923456789;اتصل بنا;mobile=>>`}</textarea>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 md-12 m-auto">
                <button
                  className="btn  submit-button m-1 text-center btn-block"
                  //  style={{ position: "right" }}
                  onClick={this.onEditSubmit.bind(this, 'submit')}
                >
                  تعديل الاقتراح
                </button>
              </div>
            </div>
          </div>
        ) : resType === 'not complete' ? (
          <NotFound></NotFound>
        ) : null}
      </div>
    );
  }
}

EditJOIN.propTypes = {
  editJoin: PropTypes.func.isRequired,
  getJoin: PropTypes.func.isRequired,
  join: PropTypes.object.isRequired,
  requestFailed: PropTypes.bool.isRequired,
  requestFailedMessage: PropTypes.object.isRequired,
  isTakingAgencyRole: PropTypes.bool.isRequired,
  ikarAdmin: PropTypes.bool.isRequired,
  requestSuccessMessage: PropTypes.string.isRequired,
  short_id: PropTypes.string.isRequired,
  resType: PropTypes.string.isRequired,
};
const mapStateToProps = (state) => ({
  ////reducers
  join: state.join.join,
  requestFailed: state.join.requestFailed,
  requestFailedMessage: state.join.requestFailedMessage,
  isTakingAgencyRole: state.auth.isTakingAgencyRole,
  takenAgencyRoleToken: state.auth.takenAgencyRoleToken,
  ikarAdmin: state.auth.ikarAdmin,
  requestSuccessMessage: state.joinUD.requestSuccessMessage,
  requestMessage: state.join.requestMessage,
  short_id: state.joinUD.short_id,
  resType: state.join.resType,
  requestMessage: state.join.requestMessage,
  // uploadedPhotoName: state.property.uploadedPhotoName,
  directory: state.join.directory,
});
export default connect(mapStateToProps, {
  editJoin,
  getJoin,
  // addPropertyPhoto,
})(EditJOIN);
